<template>
  <article class="shopReviewContent">
    <div class="shopReviewContent__container">
      <div class="shopRecommended__titleContainer">
        <h2 class="shopRecommended__title">{{ shopName }}の口コミ({{ pager.total }})</h2>
      </div>
      <h3 class="shopReviewContent__heading">口コミデータ</h3>
      <div class="shopReviews">
        <shop-review-score :shop-reviews="allShopReviews"></shop-review-score>
        <template v-if="shopReviews.length > 0">
          <div class="shopReviews__pagination-count">{{ pager.offset + 1 }}〜{{ pager.offset + pager.count }}件を表示 / 全{{ pager.total }}件</div>
          <shop-review :shop-review=shopReview v-for="shopReview in shopReviews" :key="shopReview.id"></shop-review>
          <front-pagination :pager="pager" :form="form" />
        </template>
      </div>
    </div>
  </article>
</template>

<script>
import ShopReview from './shopReview.vue';
import FrontPagination from "./frontPagination.vue";
import ShopReviewScore from "./shopReviewScore.vue";

export default {
    components: {
        'shop-review': ShopReview,
        'front-pagination': FrontPagination,
        'shop-review-score': ShopReviewScore,
    },
    props: {
        shopId: {
            required: true,
        },
        shopName: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            form: this.createForm(),
            allForm: this.createForm(),
            pager: this.createPager(5),
            shopReviews: [],
            allShopReviews: [],
        };
    },
    created: function() {
        this.fetchShopReviews();
        this.fetchAllShopReviews();
    },
    methods: {
        fetchShopReviews(opt_position) {
            const position = opt_position || this.pager.first();
            this.merge(this.form.model, position);
            this.form.model.page = parseInt(new URLSearchParams(window.location.search).get('page')) || 1;
            this.form.get(`/api/shops/${this.shopId}/reviews/`, function(response) {
                this.shopReviews = [];
                _.forEach(response.data.reviews, function(each) {
                    this.shopReviews.push(each);
                }.bind(this));
                this.pager.update(response.data.reviews, response);
            });
        },
        fetchAllShopReviews() {
            this.allForm.model.all = true;
            this.allForm.get(`/api/shops/${this.shopId}/reviews/`, function(response) {
                this.allShopReviews = [];
                _.forEach(response.data, function(each) {
                    this.allShopReviews.push(each);
                }.bind(this));
            });
        }
    }
};
</script>
